import React, { useEffect, useState } from 'react'
import styles from './gridStyles.module.scss'
import { logo, photo, experience } from '../../../assets/img/dashCategoris'
import { arrowLeft, checkGreen, closeIcon, questionIcon } from '../../../assets/svg/dashboard/main'
import { useHistory, useParams } from 'react-router-dom'
import { eduIcon3 } from '../../../assets/img/dashCategoris'
import {
  BarChart,
  PieChart,
  Pie,
  Cell,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Line,
  LineChart,
} from 'recharts';
import { useDispatch, useSelector } from 'react-redux'
import { getPhoto, getStaffDetails, getStaffList } from '../../../actions/dashboard'
import { DASHBOARD_ENTITIES } from '../../../utils/const'
import { Check } from '../../../assets/NewDashboard'
import ReactTooltip from 'react-tooltip'
import { Input, Select } from '../../../assets/NewDashboard'
import { IoPerson } from 'react-icons/io5'
import { PiSortAscending, PiSortDescending } from "react-icons/pi";



const Details = ({ spoMode }) => {

  const history = useHistory()
  const dispatch = useDispatch()
  const { id } = useParams()
  const { details } = useSelector(state => state.dashboard)

  const [filters, setFilters] = useState({fio: '', order_by: '', sort_order: 'asc'})

  useEffect(() => {
    dispatch(getStaffDetails(id, spoMode))
  }, [])
  

  useEffect(() => {
    dispatch(getStaffList(id, filters))
  }, [filters])

  const goTo = (link) => () => history.push(link)


  const { mpid_stats, list, info, stage_stats } = details.staff
  const { percent_value, result, norm } = mpid_stats
  const { chart, total_teachers, teachers_with_experience } = stage_stats || {}

  const {min, max, options} = DASHBOARD_ENTITIES[spoMode ? 'spo' : 'high'].workers

  const normDescription = norm ? `Требование ФГОС - ${norm}%` : 'Требование ФГОС не заполнено'

  return (
    <div>
      <section className={styles.detailsWrap}>
        <div onClick={goTo(`/dashboard_new/accreditation${spoMode ? '?level=spo' : ''}`)}>
          <div>{arrowLeft}</div>
          <h2>{info?.name}</h2>
        </div>
        <div className={styles.dashBlock}>
          <section className={styles.firstSection}>
            <div>
              <div>
                <div style={{flexDirection: 'row'}}>
                  <img src={eduIcon3} alt='о_О' />
                  <p className={styles.pStyles}>Доля работников,<br/>имеющих стаж<br/>работы<br/>реализуемой<br/>программы</p>
                </div>
                <div>
                  {result < max ? 'не соответствует' : 'соответствует'}
                  {result < max ? closeIcon : checkGreen}
                </div>
              </div>
              <div>
                <PieChartComponent percentage={percent_value} />
              </div>
            </div>
            <div>
              <div>
                <i data-tip='custom-jsx-tooltip' data-for="custom-jsx-tooltip">{questionIcon}</i>
                <ReactTooltip id="custom-jsx-tooltip" className={styles.tooltip}>
                  <p>Критериальное значение аккредитационного показателя</p>
                  <text>{normDescription}</text>
                  <ul>{options.map((i) => <li>{i}</li>)}</ul>
                </ReactTooltip>
                <Check
                  className={styles.checkBlock}
                  mode={result >= max ? `complete` : result <= min ? `notComplete` : `middle`}
                />
              </div>
              <p>{result}</p>
              <p>баллов</p>
              <p>аккредитационного</p>
              <p>показателя</p>
            </div>
          </section>
          <section className={styles.secondSection}>
            <div>
              <Input
                placeholder='поиск'
                onChange={(fio) => setFilters({...filters, fio})}
              />
              <Select
                value={filters.order_by}
                onChange={(e) => setFilters({...filters, order_by: e.target.value})}
              >
                <option selected hidden>Сортировать по</option>
                <option value='fio'>ФИО</option>
                <option value='category'>Ученая степень/звание</option>
                <option value='years_stag'>Стаж</option>
                <option value='department'>Подразделение</option>
              </Select>
              <div 
                className={styles.sortIcon}
                onClick={() => setFilters({...filters, sort_order: filters.sort_order === 'asc' ? 'desc' : 'asc'})}
              >
                {filters.sort_order === 'asc' ? <PiSortAscending /> : <PiSortDescending />}
              </div>
            </div>
            <div>
              {!!list?.length && <ul>{list?.map(user => <User user={user}/>)}</ul>}
              {!list?.length && <div className={styles.noData}>Данные отсутствуют</div>}
            </div>
          </section>
          <section className={styles.thirdSection}>
            <Chart data={chart}/>
            <div>
              <div>Всего: {total_teachers}</div>
              <div>Имеющих стаж: {teachers_with_experience}</div>
            </div>
          </section>
        </div>
      </section>
    </div>
  )
}



const User = ({user}) => {
  
  const { fio, category, name, years_stag, mid } = user
  const position = [category, name].filter(Boolean).join(', ')

  const dispatch = useDispatch()
  
  const [photo, setPhoto] = useState('')
  
  useEffect(async () => {
    const photoUrl = await dispatch(getPhoto(mid))
    setPhoto(photoUrl)
  }, [user])
  
  
  return (
    <li className={styles.userBlock}>
      <div>
        {photo ? <img src={photo} alt="photo" /> : <IoPerson size={50} color='#5c76e3'/>}
      </div>
      <div>
        <p>{fio}</p>
        <p>{position}</p>
      </div>
      <div>
        <img src={experience} alt="experience" />
        <div>
          <p>{years_stag}</p>
          <p>года</p>
        </div>
      </div>
    </li>
)}

const PieChartComponent = ({percentage}) => {
  
  const step = 0.5;
  const countSteps = Math.round(percentage / step);

  const gradientData = Array.from({ length: countSteps }, (_, i) => {
    const hue = 120 * percentage / 100 * (1 - (countSteps - i) / countSteps)
    const color = `hsl(${hue}, 100%, 50%)`;
    return { value: step, color };
  });

  const pieData = [
    ...gradientData,
    { value: 100 - percentage, color: '#fff' },
  ];


  return (
    <ResponsiveContainer width={200} height={200} style={{ margin: '0 auto', display: 'block' }}>
      <PieChart>
        <Pie
          data={pieData}
          cx="50%"
          cy="50%"
          innerRadius={40}   
          outerRadius={60}   
          // fill="#5B76E5"
          dataKey="value"
          nameKey="name"
          stroke='none'
          // label
        >
          {pieData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} stroke="none" />
          ))}
        </Pie>
        <text
          x="50%"
          y="52%"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize="25"
          fontWeight="bold"
          // fill="#5B76E5"
        >
          {percentage}%
        </text>
        {/* <Tooltip /> */}
        {/* <Legend /> */}
      </PieChart>
    </ResponsiveContainer>
  )
}

const Chart = ({data}) => {
  
  
  const getTicksRange = (data, field) => {
    const maxY = data?.length > 0 ? Math.max(...data.map(item => item[field])) : 0;
    const maxTick = Math.ceil(maxY) + 1; // или maxY + 1, если maxY — целое
    return Array.from({ length: maxTick + 1 }, (_, i) => i);
  }

  const yTicks = getTicksRange(data, 'teacher_count');
  const xTicks = getTicksRange(data, 'years_stag');

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data} margin={{ bottom: 30, left: 30 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="years_stag"
          type='number'
          label={{
            value: 'стаж, лет',
            position: 'insideBottom',
            offset: -10,
            fontWeight: 'bold',
            style: {
              fontSize: '12px',
              fill: '#000',
            },
          }}
          // domain={[0, 'auto']}
          ticks={xTicks}
        />
        <YAxis
          label={{
            value: 'кол-во преподавателей',
            angle: -90,
            position: 'insideLeft',
            dx: -10,
            dy: 0,
            fontWeight: 'bold',
            style: {
              fontSize: '12px',
              fill: '#000',
              textAnchor: 'middle',
            },
          }}
          // domain={[0, maxY + 1]}
          ticks={yTicks}
        />
        <Tooltip />
        {/* <Legend /> */}
        <Line
          type="monotone"        // ← делает кривую гладкой
          dataKey="teacher_count"
          name="Кол-во преподавателей"
          stroke="#5B76E5"       // цвет линии
          strokeWidth={5}
          dot={{ r: 4, fill: '#5B76E5' }}     // точки на узлах
          activeDot={{ r: 6, stroke: '#fff', strokeWidth: 2 }} // при наведении
        />
      </LineChart>
    </ResponsiveContainer>
  )
}

export default Details